import { Component, OnInit, OnDestroy, Inject, DoCheck, AfterContentInit } from '@angular/core';
import { IClassService } from '../../Services/class-service';
import { MatDialog } from '@angular/material/dialog';
import { ElearningdashClassmgmtDialogComponent } from './../elearningdash-classmgmt-dialog/elearningdash-classmgmt-dialog.component';
import { IServiceFactory } from '../../Services/service-factory';
import { ITeacherService } from '../../Services/teacher-service';
import { ELearningDashboardClass, Teacher, Teachers, ELearningDashboardStudent, ELearningDashboardState } from '../../Elearning-Models';
import { IStateService } from '../../Services/state-service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Component({
  selector: 'app-elearning-dashboard',
  templateUrl: './elearning-dashboard.component.html',
  styleUrls: ['./elearning-dashboard.component.scss']
}) 
export class ELearningDashboardComponent implements OnInit {
  // Teacher services and data

  selectedTeacher: BehaviorSubject<string> = new BehaviorSubject<string>(""); // for filtering admin

  teacherService: ITeacherService; // middle man for api-service for teachers
  teachers: Teacher[] = []; // data from teacher service

  // Class services and data
  classService: IClassService; // middle man for api-service for classes

  classes: ELearningDashboardClass[] = []; // data from class service
  classesBehaviorSubject: BehaviorSubject<ELearningDashboardClass[]> = new BehaviorSubject<ELearningDashboardClass[]>(null);
  
  isAdmin: boolean;
  isAdminBehaviorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  // State save
  stateService: IStateService;
  state: ELearningDashboardState = new ELearningDashboardState();

  // These two booleans ensure we don't see flickering responses when waiting for our first data call
  receivedTeacherDataBehaviorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  receivedClassDataBehaviorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  // For flickering reponses for admin
  classDataForAdminReceivedBehaviorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null); 

  stateReceivedBehviorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  hasAnchorFeature: boolean;
  delayedAnchorInterval: number = 1000;

  stateInitializedBehaviorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  // used to listen for when the teachers and state api calls are done to do the class api call
  stateAndteacherBehaviorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);



  constructor(public dialog: MatDialog, private serviceFactory: IServiceFactory) {
    this.classService = serviceFactory.getClassService();
    this.teacherService = serviceFactory.getTeacherService();
    this.stateService = serviceFactory.getStateService();
  }



  ngOnInit(): void {

    this.classDataForAdminReceivedBehaviorSubject.subscribe(received => {
      if (received == null){
        return;
      }

      this.setDataReceived();

      this.setIfTeacherHasNoClasses();
    });

    this.stateReceivedBehviorSubject.subscribe(received => {
      if (received != null){
        this.setDataReceived();
      }
    });

    this.receivedTeacherDataBehaviorSubject.subscribe(received => {
      this.setDataReceived();
  
      // Teacher data sets both teachers[] and isAdmin
      this.setIfNoTeachersAvailable();
      this.setIfNoTeacherSelected();
    });
    
    // initiates class service and subscribes to emitter
    this.setClassesFromService();

    // waits for both state and teacher apis to be finished before calling to get classes
    this.stateAndteacherBehaviorSubject.subscribe((_: any) => {
      if (_ == null){
        return;
      }

      this.getOrSetClassesFromState();
      if(this.hasAnchorFeature)
      {
        if(this.state.Anchor)
        {
          setTimeout(() => window.scrollBy(0,this.state.Anchor), this.delayedAnchorInterval);
        } 
      }
    });

    // calls api service to get state api/getelearningdashboardstate
    this.setStateFromService();

    // which calls api-service to get teachers api/Teachers
    this.setTeachersFromService();
  }


  stateAndTeacherEmit(){
    if(
      this.stateReceivedBehviorSubject.value 
      && this.receivedTeacherDataBehaviorSubject.value 
      && !this.stateInitializedBehaviorSubject.value
    ){
      this.stateAndteacherBehaviorSubject.next(true);
      this.stateInitializedBehaviorSubject.next(true);
    }
  }

//////////////////////////////////////////////////////////////
//              Pop Up Dialog - Class Management           //

  openClassFilterMgmtDlg(){
    let dialogRef = this.dialog.open(ElearningdashClassmgmtDialogComponent, {
      width: '1000px',
      panelClass: 'custom-modalbox', 
    });

    dialogRef.componentInstance.serviceFactory = this.serviceFactory;
  }

//////////////////////////////////////////////////////////////
//                        CLASSES                          //

// For filtering classes
  populateClasses: ELearningDashboardClass[];

  private setClassesFromService() {
    this.classService.classesAvailableEmitter
      .subscribe((result: ELearningDashboardClass[]) => {
        if (result) {
          this.onClassesAvailableUpdate(result);
        }
      });
  }

  // From Class Service to grab classes
  onClassesAvailableUpdate(result : ELearningDashboardClass[]){

    this.classes = result.sort((a,b) => this.sortClassFunction(a.Name, b.Name, a.CurriculumID, b.CurriculumID));
    this.classes.forEach(c => c.Students.sort((a, b) => this.sortFunction(a.Name, b.Name)));
    this.populateClasses = this.classes.filter(c => c.Hidden == false);

  
    this.receivedClassDataBehaviorSubject.next(true);
    if(this.selectedTeacher.value != "" || this.state.TeacherID){
      this.classDataForAdminReceivedBehaviorSubject.next(true);
    }
    else{
      this.classDataForAdminReceivedBehaviorSubject.next(false);
    }
  
    this.setIfTeacherNoClassesToDisplay();
    this.setIfAllClassesHidden();
    this.setIfTeacherAndHaveClasses();
    this.setTeacherHasStudents();
    this.setIfTeacherOrSelectedTeacher();
    this.setIfNoTeachersAvailable();
    this.setIfNoTeacherSelected();
  }

  //////////////////////////////////////////////////////////////
  //                      TEACHERS                           //

  // For filtering teacher text box, grabs all teachers for searching
  // might not need this since we will be calling for teachers
  getTeachers(){
    if(this.teachers){
      return this.teachers;
    }
    return [];
  }

  private setTeachersFromService() {
    this.teacherService.teachersAvailableEmitter.subscribe((result: Teachers) => {
      if (result) {
        this.onTeachersAvailableUpdate(result);
      }
    });
    this.teacherService.GetOrSetTeachers();
  }

  onTeachersAvailableUpdate(result: Teachers){
    // check for empty result?
    this.teachers = result.Teachers;
    this.isAdmin = result.IsAdmin;
    this.receivedTeacherDataBehaviorSubject.next(true);
    this.stateAndTeacherEmit();
    if(this.teachers.length > 0){
      this.teachers.sort((a,b) => this.sortFunction(a.FirstName, b.FirstName));
    }
  }

  // For filtering teacher
  filterTeacher(teacher: Teacher){
    this.classDataForAdminReceivedBehaviorSubject.next(false);
    // set value for filtering classes
    this.selectedTeacher.next(teacher.FirstName + " " + teacher.LastName);

    // Use class service to get classes from specific teacher
    this.classService.GetOrSetClasses(teacher.UserID);
    this.stateService.setState(null, null, null, teacher.UserID);
    
    this.setIfNoTeacherSelected();
  }

 //////////////////////////////////////////////////////////////
//                        State                             //
setStateFromService(){
  // Calls state-service
  this.hasAnchorFeature = this.stateService.hasAnchorFeature();

   this.stateService.stateEmitter.subscribe((result: ELearningDashboardState) => {
    if(result){
      this.copyStateFromStateService(result);
    }
    // If no result - the state is blank already so no need to do anything
    this.stateReceivedBehviorSubject.next(true);
    this.stateAndTeacherEmit();
   });
 }

  private copyStateFromStateService(stateFromService: ELearningDashboardState) {
    if(!this.stateReceivedBehviorSubject.value){
      this.state.copyFromModel(stateFromService);
    }
  }

  private getOrSetClassesFromState() {
  
      if (this.state.TeacherID && this.isAdmin) {
        this.classService.GetOrSetClasses(this.state.TeacherID);
      }
      else {
        this.classService.GetOrSetClasses();
      }

  }

 saveState(){
   this.stateService.setState(null, null, window.scrollY, null);
   this.stateService.saveState();
 }

 //////////////////////////////////////////////////////////////
//                       Reponse                            //


  dataReceived: boolean = false;
  setDataReceived()
  {
    if (
      this.receivedClassDataBehaviorSubject.value 
      && this.receivedTeacherDataBehaviorSubject.value 
      && this.stateReceivedBehviorSubject.value
    ) {
      this.dataReceived = true;
    }
    else {
      this.dataReceived = false;
    }
  } 

  /////////////// Admin reponses
  ifNoTeachersAvailable: boolean  = false;
  setIfNoTeachersAvailable(){
    if(this.isAdmin && this.teachers.length == 0)
    {
      this.ifNoTeachersAvailable = true;
    } else {
      this.ifNoTeachersAvailable = false;
    }
  }

  ifTeacherHasNoClasses: boolean = false;

  setIfTeacherHasNoClasses(){
    if(this.isAdmin 
      && this.selectedTeacher.value != "" 
      && this.classes.length == 0 
      && this.classDataForAdminReceivedBehaviorSubject.value)
    { 
      this.ifTeacherHasNoClasses = true;
    }
    else{
      this.ifTeacherHasNoClasses = false;
    } 
  }

  ifNoTeacherSelected: boolean = false;
  setIfNoTeacherSelected(){
    // has state
    if(this.isAdmin && this.state.TeacherID){
      this.ifNoTeacherSelected = false; 
    }
    else if(this.isAdmin && this.selectedTeacher.value == "" && this.teachers.length > 0)
    {
      this.ifNoTeacherSelected =  true;
    }
    else{
      this.ifNoTeacherSelected = false;
    }
  }

  ////////////// Teacher reponses
  ifTeacherNoClassesToDisplay: boolean = false;
  setIfTeacherNoClassesToDisplay(){
    // classes
    if(!this.isAdmin && this.classes.length == 0)
    {
      this.ifTeacherNoClassesToDisplay = true;
    }
    else{
      this.ifTeacherNoClassesToDisplay = false;
    }
  }
  ifAllClassesHidden: boolean = false;
  setIfAllClassesHidden(){
    // classes
    if(!this.isAdmin && this.classes.length > 0 && this.populateClasses.length == 0)
    {// if teacher and I have classes but my dashboard is empty
      this.ifAllClassesHidden = true;
    }
    else{
      this.ifAllClassesHidden = false;
    }
  }


  /////////////////////////// Functions
  sortFunction(a: String, b: String){
   
    if(a < b)
    {
      return -1;
    }
    else if(a > b)
    {
      return 1;
    }
    else
    {
      return 0;
    }
  }

  sortClassFunction(a: String, b: String, curridA: number, curridB: number){
    if(curridA == null && curridB != null)
    {// then a goes after since b has a curriculum
      return 1;
    }

    if(curridA != null && curridB == null)
    { // then a goes before b since b has no curriculum
      return -1;
    }

    // else just sort by string
    return this.sortFunction(a, b);
  }

  ////////////////// HTML
  ifTeacherAndHaveClasses: boolean = false;
  setIfTeacherAndHaveClasses(){
    // classes
    if(!this.isAdmin && this.classes.length > 0){
      this.ifTeacherAndHaveClasses = true;
    }
    else{
      this.ifTeacherAndHaveClasses = false;
    }
  }

  ifTeacherOrSelectedTeacher: boolean = false;
  setIfTeacherOrSelectedTeacher(){

    // state, classes, selected teacher
    // For student filter
    if(this.isAdmin && this.state.TeacherID){
      this.ifTeacherOrSelectedTeacher = true; 
    }
    else if(this.isAdmin && this.selectedTeacher.value)
    {
      //if this is admin - we only see the student filter if they selected a teacher and that teacher has students
      this.ifTeacherOrSelectedTeacher = this.teacherHasStudents;
    }
    else if(!this.isAdmin){
      // if a teacher - we see student filter if we have students...
      this.ifTeacherOrSelectedTeacher = this.teacherHasStudents;
    }
    else{
      this.ifTeacherOrSelectedTeacher = false;
    }

  }

  teacherHasStudents: boolean = false;
  setTeacherHasStudents(){
    // classes
    this.teacherHasStudents = this.classes.some(clas => {
      return clas.Students.length > 0;
    });
  }


}